
import StatusBadge from "./StatusBadge";
import StatusSelector from "./StatusSelector";

interface StatusSectionProps {
  status: string;
  isUpdating: boolean;
  onStatusChange: (status: string) => void;
}

const StatusSection = ({ status, isUpdating, onStatusChange }: StatusSectionProps) => {
  return (
    <div className="flex items-center gap-3 ml-auto mt-2 sm:mt-0">
      <StatusBadge 
        status={status} 
        isUpdating={isUpdating} 
      />
      <StatusSelector 
        status={status} 
        isUpdating={isUpdating} 
        onStatusChange={onStatusChange} 
      />
    </div>
  );
};

export default StatusSection;
